import * as React from "react";

const UserCheckIcon = (props) => (
	<svg
		width={props.width ? props.width : 24}
		height={props.height ? props.height : 24}
		viewBox={`0 0 ${props.width ? props.width : 24} ${props.height ? props.height : 24}`}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M15 19C15 16.7909 12.3137 15 9 15C5.68629 15 3 16.7909 3 19M21 10L17 14L15 12M9 12C6.79086 12 5 10.2091 5 8C5 5.79086 6.79086 4 9 4C11.2091 4 13 5.79086 13 8C13 10.2091 11.2091 12 9 12Z"
			stroke={props.color ? props.color : "white"}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default UserCheckIcon;
